import { render } from "./NotAuthorized.vue?vue&type=template&id=44737644&scoped=true"
import script from "./NotAuthorized.vue?vue&type=script&lang=js"
export * from "./NotAuthorized.vue?vue&type=script&lang=js"

import "./NotAuthorized.vue?vue&type=style&index=0&id=44737644&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Desktop/Progetti/ask_landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44737644"]])

export default __exports__